import { NoticeMessage } from "UI/FnrNoticeMessage";

export default function ErrorBoundaryFallback() {
  return (
    <NoticeMessage>
      <p>Oh no! Something went wrong.</p>
      <p>
        If the problem persists, please get help at{" "}
        <a href="mailto:help@flocknote.com?subject=DashboardCards Error">
          help@flocknote.com
        </a>
      </p>
    </NoticeMessage>
  );
}
